<div class="dialog-container">
  <!-- Success Screen -->
  <div class="success-screen" *ngIf="paymentSuccess">
    <div class="success-icon-wrap">
      <i class="fa-solid fa-circle-check"></i>
    </div>
    <h3>Payment Successful!</h3>
    <p>
      Added <strong>+{{ data.extraBookingCount }}</strong> manual bookings to your limit.
    </p>
  </div>

  <!-- Main Payment Screen -->
  <ng-container *ngIf="!paymentSuccess">
    <div class="dialog-header">
      <div class="header-left">
        <h3>Buy Extra Bookings</h3>
        <p class="subtitle">
          <i class="fa-solid fa-lock"></i> Secure payment powered by Stripe
        </p>
      </div>
      <button class="btn-close" (click)="close()" [disabled]="isProcessing">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="summary-card">
      <div class="summary-row">
        <span>Extra Bookings</span>
        <strong class="highlight-text">+{{ data.extraBookingCount }} bookings</strong>
      </div>
      <div class="summary-row">
        <span>Rate</span>
        <strong>AED {{ data.extraBookingPrice }} / pack</strong>
      </div>
      <div class="divider"></div>
      <div class="summary-row total-row">
        <span>Total due today</span>
        <strong class="total-amount">AED {{ data.extraBookingPrice }}</strong>
      </div>
    </div>

    <div class="payment-section">
      <label class="input-label">Card Details</label>
      <div class="card-element-container">
        <div id="extra-booking-card-element"></div>
      </div>
      <p class="note">
        <i class="fa-solid fa-circle-info"></i>
        These bookings will be added to your current cycle limit.
      </p>
    </div>

    <!-- Error Alert -->
    <div class="error-banner" *ngIf="paymentError">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <span>{{ paymentError }}</span>
    </div>

    <div class="dialog-actions">
      <button class="btn-cancel" (click)="close()" [disabled]="isProcessing">
        Cancel
      </button>
      <button class="btn-pay" (click)="pay()" [disabled]="isProcessing">
        <ng-container *ngIf="!isProcessing">
          <i class="fa-solid fa-bolt"></i>
          Pay AED {{ data.extraBookingPrice }}
        </ng-container>
        <ng-container *ngIf="isProcessing">
          <i class="fa-solid fa-spinner fa-spin"></i>
          Processing...
        </ng-container>
      </button>
    </div>
  </ng-container>
</div>
